<template>
	<v-container>
		<v-app-bar app color="red">
			<div class="d-flex d-lg-none">
				<v-app-bar-nav-icon
					@click.stop="$emit('drawer-change')"
				></v-app-bar-nav-icon>
			</div>

			<v-toolbar-title class="white--text">
				<span class="d-none d-sm-inline" v-if="decreto && decreto.id">Detalhes do </span>
				<span class="d-none d-sm-inline" v-else>Novo </span>
				Decreto
			</v-toolbar-title>
		</v-app-bar>

		<!-- dados do decreto -->
		<v-row>
			<v-col class="pt-0 pb-0" cols="12" md="2" sm="4">
				<v-text-field
					v-model="anoExercicio"
					:rules="[
						$rules.required(), 
						$rules.between(intervaloAno)
					]"
					label="Ano Exercício"
					required
					type="number"
					disabled
				/>
			</v-col>
			
			<v-col class="pt-0 pb-0" cols="12" md="2" sm="4">
				<v-text-field
					v-model="numeroDecreto"
					:rules="[
						$rules.required(),
						v => (v < 0 ? 'Valor deve ser maior que zero.' : true)
					]"
					label="Nr. Decreto"
					required
					type="number"
					autofocus
				/>
			</v-col>

			<v-col class="pt-0 pb-0" cols="12" md="2" sm="4">
				<v-text-field
					v-model="dataDecreto"
					:rules="[$rules.required(),
							$rules.validDate()]"
					v-mask="'##/##/####'"
					label="Data do Decreto"
					required
					autofocus
				/>
			</v-col>
		</v-row>

		<v-app-bar color="red lighten-4" >

				<v-tabs v-model="tab" centered color="red darken-4" icons-and-text>
					<v-tabs-slider></v-tabs-slider>

					<v-tab href="#tabDotacoesAnular">
						Dotações a Anular
						<v-icon>mdi-cash-multiple</v-icon>
					</v-tab>

					<v-tab href="#tabDotacoesSuplementar">
						Dotações a Suplementar
						<v-icon>mdi-cash</v-icon>
					</v-tab>

				</v-tabs>

		</v-app-bar>

		<v-card tile>
			<v-container>
				
				<!-- dotações do decreto -->
				<v-decreto-form
					v-model="decreto"
					:tab="tab"
					@salvando="v => (salvarLoading = v)"
					@removendo="v => (removerLoading = v)"
					@saved="salvo"
					@updated="salvo"
					ref="decretoForm"
					@snack="v => this.$emit('snack',v)"
					:diferenca="diferencaDotacao"
				/>

				<!-- rodapé - valores totais -->
				<v-row>
					<v-col md="3">
						<v-text-field
							class="centered-input"
							label="Valor Total Anulado"
							:value="valorTotalAnulado$"
							placeholder="0"
							filled
							rounded
							dense
							readonly
						/>
					</v-col>
					<v-col md="3">
						<v-text-field
							class="centered-input"
							label="Valor Total Suplementado"
							:value="valorTotalSuplementado$"
							placeholder="0"
							filled
							rounded
							dense
							readonly
						/>
					</v-col>
					<v-col md="3">
						<v-text-field
							:class="[
								'centered-input',
								diferencaDotacao < 0 ? 'verde' : '',
								diferencaDotacao > 0.001 ? 'vermelho' : ''
							]"
							label="Diferença"
							:value="diferencaDotacao$"
							placeholder="0"
							filled
							rounded
							dense
							readonly
						/>
					</v-col>

				</v-row>
			</v-container>
		</v-card>

		<v-row> 
			<v-col >
				<v-btn class="mr-5" color="primary" v-if="decreto && decreto.id" @click="imprimirDecreto(decreto.id, decreto.numeroDecreto)">Imprimir Decreto</v-btn>
				<v-btn color="blue lightnen-5" v-if="decreto && decreto.id" @click="imprimirPlanilha(decreto.id, decreto.numeroDecreto)">Gerar Planilha Decreto</v-btn>
			</v-col>

			<v-col class="text-right" justify-end width="100%">

				<v-btn text class="mr-5" @click="cancelar">Cancelar</v-btn>
				<v-dialog
					v-model="dialog"
					persistent
					max-width="350"
					v-if="tab == 'tabGeral'"
				>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							class="mr-5"
							color="error"
							:loading="removerLoading"
							:disabled="removerLoading || formDesativado"
							@click="removerdecreto"
							v-bind="attrs"
							v-on="on"
							
						>
							Remover
						</v-btn>
					</template>
					<v-card>
						<v-card-title class="headline">
							Voce tem certeza disso?
						</v-card-title>
						<v-card-text v-if="decreto">
							<p>
								Você confirma a exclusão do decreto
								{{ decreto.numeroDecreto }}?
							</p>
							<p>{{ decreto.descricao }}</p>
						</v-card-text>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn text @click="cancelarRemocao">
								Cancelar
							</v-btn>
							<v-btn color="error" text @click="confirmarRemocao">
								Confirmar
							</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>
				<v-btn
					color="primary"
					:loading="salvarLoading"
					:disabled="salvarLoading || formDesativado"
					@click="salvardecreto"
				>
					Salvar
				</v-btn>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import { getYear } from 'date-fns';
import VDecretoForm from '@/forms/DecretoForm.vue';
import { Vue } from '@/main';
//import _ from 'lodash';

export default {
	components: { VDecretoForm },
	data() {
		return {
			pesqEmenda: false,
			decreto: null,
			numeroDecreto: null,
			dataDecreto: null,
			numeroEmenda: null,
			anoExercicio: null,
			valor: 0,
			dotacoesDecreto: [],
			dotacoesEmenda: [],
			salvarLoading: false,
			removerLoading: false,
			dialog: false,
			tab: 'tabDotacoesAnular',
			esferaItems: [],
			intervaloAno: {
				start: 1900,
				end: getYear(new Date()) + 4,
				msg: 'Ano inválido. Deve ser entre ${start} e ${end}'
			},
			descrEsfera : null
		};
	},

	watch: { 
		numeroDecreto(value) {
			if (this.decretoForm) {
				this.decretoForm.numeroDecreto = value;
			}
		},

		dataDecreto(value) {
			if (this.decretoForm) {
				this.decretoForm.dataDecreto = value;
			}
		},

		anoExercicio(value) {
			if (this.decretoForm) {
				this.decretoForm.anoExercicio = value;
			}
		},

		valor(value) {
			if (this.decretoForm) {
				this.decretoForm.valor = value;
			}
		},

		dotacoesEmenda(value) {
			if (this.decretoForm) {
				this.decretoForm.dotacoesEmenda = value;
			}
		}

	},

	computed: {
		decretoForm() {
			let ComponentClass = Vue.extend(VDecretoForm);
			let decretoForm = new ComponentClass();
			if (this.decreto && this.$refs && this.$refs.decretoForm) {
				return this.$refs.decretoForm;
			} else {
				return decretoForm;
			}
		},

		formDesativado() {
			if (this.$root.usuarioLogado &&
					this.$root.usuarioLogado.funcoes &&
					this.$root.usuarioLogado.funcoes.includes('EMENDA_ALTERAR')) {
				return false;
			// } else if (this.decreto && this.decreto.decretoSituacao && this.decreto.decretoSituacao.id === 3) {
			// 	return false;
			} else {
				return true;
			}
		},

		valorTotalAnulado() {
			if (this.decretoForm.dotacoesDecretoAnular && this.decretoForm.dotacoesDecretoAnular.length > 0) {
				return this.decretoForm.dotacoesDecretoAnular.reduce((a, b) => a + (parseFloat(b.valorAnulado) || 0), 0);
			} else {
				return 0;
			}
		},
		
		valorTotalAnulado$() {
			return this.setMascara(this.valorTotalAnulado);
		},

		valor$() {
			return this.setMascara(this.valor);
		},

		valorTotalSuplementado() {
			if (this.decretoForm.dotacoesDecretoSuplementar && this.decretoForm.dotacoesDecretoSuplementar.length > 0) {
				return this.decretoForm.dotacoesDecretoSuplementar.reduce((a, b) => a + (parseFloat(b.valorSuplementado) || 0), 0);
			} else {
				return 0;
			}
		},
		
		valorTotalSuplementado$() {
			return this.setMascara(this.valorTotalSuplementado);
		},

		diferencaDotacao() {
			return this.valorTotalAnulado - this.valorTotalSuplementado;
		},
		
		diferencaDotacao$() {
			return this.setMascara(this.diferencaDotacao);
		}

	},
	
	async created() {
		if (this.$route.params.id !== 'novo') {
			this.decreto = await this.decretoForm.obterDecreto(this.$route.params.id);
			this.numeroDecreto = this.decreto.numeroDecreto;
			this.anoExercicio = this.decreto.anoExercicio
			this.dataDecreto = this.decreto.dataDecreto;
		}
		else {
			// novo decreto
			this.anoExercicio = this.$root.anoSelecionado;
		}
		
		// [
		// 	this.esferaItems
		// ] = await this.$fetch.getAll([
		// 	`parlamentares/esferas`
		// ]);

	},

	methods: {
		async salvardecreto() {
			await this.decretoForm.salvar();
		},

		// exibirTramitar() {
		// 	this.decretoForm.exibirTramitar();
		// },
		
		async removerdecreto() {
			this.dialog = true;
		},

		cancelar() {
			this.$router.replace('/decretos');
		},

		async confirmarRemocao() {
			let decretoRemovida = await this.decretoForm.remover();
			if (decretoRemovida && decretoRemovida.id) {
				this.$emit('snack', {
					show: true,
					text: `decreto ${decretoRemovida.numeroDecreto} removida com sucesso`
				});
				this.$router.replace('/decretos');
			}
			this.dialog = false;
		},
		
		cancelarRemocao() {
			this.dialog = false;
		},
		
		salvo(decretoSalva) {
			if (decretoSalva && decretoSalva.id) {
				this.$emit('snack', {
					show: true,
					text: `Decreto ${decretoSalva.numeroDecreto} salvo com sucesso`
				});
				this.$router.replace('/decretos');
			}
		},

		setMascara(v) {
			return parseFloat(v).toLocaleString('pt-BR', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2,
				style: 'currency',
				currency: 'BRL'
			});
		},

		imprimirDecreto(id, numeroDecreto) {
			var url = `api/decretos/${id}/imprimir`;
			var fileName = `Decreto ${numeroDecreto}.pdf`;
			var link = document.createElement('a');
			link.href = url;
			link.download = fileName;
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		},

		imprimirPlanilha(id, numeroDecreto) {
			var url = `api/decretos/${id}/planilha`;
			var fileName = `Decreto ${numeroDecreto}.xlsx`;
			var link = document.createElement('a');
			link.href = url;
			link.download = fileName;
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		}

	}
};
</script>

<style scoped>
.verde >>> .v-input__slot {
	background-color: #95ff9d !important;
}

.label-cinza {
	-webkit-text-size-adjust: 100%;
    word-break: normal;
    tab-size: 4;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    font-family: "Roboto", sans-serif;
    letter-spacing: normal;
    text-align: left;
    background-repeat: no-repeat;
    box-sizing: inherit;
    padding: 0;
    margin: 0;
    font-size: 13px;
    min-height: 8px;
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    overflow: hidden;
    text-overflow: ellipsis;
    top: 6px;
    white-space: nowrap;
    pointer-events: none;
    max-width: 133%;
    transform: translateY(-18px) scale(0.75);
    height: 16px;
    line-height: 20px;
    color: rgba(0, 0, 0, 0.6);
    transform-origin: top left;
    left: 0px;
    right: auto;
	font-family: Roboto, sans-serif;
	text-size-adjust: 100%;
    /* position: absolute; */
}
</style>